"use strict";

module.exports = function (accumulator, order, product) {
  var addition = product.paper_type === 'Double Thick White Matte' ? 'Set paper size to 13x19' : '';

  if (accumulator.length && addition.length) {
    return "".concat(accumulator, "\n").concat(addition);
  }

  return "".concat(accumulator).concat(addition);
};